module.exports = __webpack_public_path__ + "static/media/Videoicon.fd9b7913.svg";